Ext.define('SA.view.sidebar.data.DataSearchResultsPlaceholder', {
    alias: 'widget.data-search-results-placeholder',
    extend: 'Ext.Component',

    cls: 'sa-data-search-results-placeholder',

    initEvents() {
        this.callParent();

        this.el.on('mouseover', this.onMouseOver, this);
    },

    onMouseOver() {
        var {el, placeholder} = this,
            {count} = placeholder,
            tooltipText = count ? `${count} ${count > 1 ? 'variables' : 'variable'}` : SA.view.sidebar.data.DataSearchResults.getDisplayName(placeholder);

        new SA.Tooltip({content: Ext.String.htmlEncode(tooltipText), target: el.dom});
    }
});